import image1 from '@/assets/images/news/detail/20201028/1.jpg';
import image2 from '@/assets/images/news/detail/20201028/2.jpg';
import image3 from '@/assets/images/news/detail/20201028/3.jpg';
import image4 from '@/assets/images/news/detail/20201028/4.jpg';
import image5 from '@/assets/images/news/detail/20201028/5.jpg';
import image6 from '@/assets/images/news/detail/20201028/6.jpg';
import image7 from '@/assets/images/news/detail/20201028/7.jpg';
import image8 from '@/assets/images/news/detail/20201028/8.jpg';
import image9 from '@/assets/images/news/detail/20201028/9.jpg';
import image10 from '@/assets/images/news/detail/20201028/10.jpg';

export default {
  id: '20201028', //  模块 id
  title: '放肆青春 从心出发|生命之战之上海特区成立1周年庆典', // 标题
  origin: '', // 新闻来源
  editor: '', // 编辑者
  content: [
    {
      type: 0,
      text:
        '初秋的烈火体育中心，充满着青春洋溢的气息，火红的地毯，马卡龙色的气球营造的气球海洋，精致的甜品、芬芳的水果和庆祝香槟......无不提示着大家，这里，即将举办一次重要的庆祝活动。',
      isIndent: false,
    },
    {
      type: 2,
    },
    {
      type: 0,
      text:
        '2019年10月28日，为提升公司运营效率，上海事业部九新、松江、淮海、上南、佘山5个区域，单独组建成立了“生命之战之上海特区”。而今天，正是上海特区成立1周年的日子，特区各服务站的小伙伴们团聚在此，共同庆祝上海特区成立1周年。',
      isIndent: false,
    },
    {
      type: 2,
    },
    {
      type: 0,
      text: '与传统的庆祝方式不同，',
      isIndent: false,
    },
    {
      type: 0,
      text: '今天是属于特区小伙伴们的正装主题party，',
      isIndent: false,
    },
    {
      type: 0,
      text: '我们来看看小伙伴们的开场红毯show吧！',
      isIndent: false,
    },
    {
      type: 2,
    },
    {
      type: 0,
      text: '「将头发梳成大人模样 穿上一身帅气西装」',
      isIndent: false,
    },
    {
      type: 0,
      text: '迪士尼在逃公主&王子们纷纷献上自己的红毯首秀~',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image1],
    },
    {
      type: 1,
      title: '',
      src: [image2],
    },
    {
      type: 0,
      text: '节目和游戏环节，',
      isIndent: false,
    },
    {
      type: 0,
      text: '小伙伴们妙趣横生、多才多艺的表演，',
      isIndent: false,
    },
    {
      type: 0,
      text: '让人过目不忘~',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '来自九新区域的舞蹈表演《你笑起来真好看》、上南区域的《粉红色的回忆》、虹桥区域的《小猪佩奇》，收获了一大批“粉丝”共舞；来自青浦区域《小酒窝》、淮海区域《童话》男女对唱节目，让空气中洋溢着满满的粉红泡泡；古筝独奏《雪山春晓》、吉他弹唱《成都》，小伙伴的才艺着实惊艳到了大家，请收下我们的膝盖；佘山区域的合唱节目《真心英雄》、淮海区域的手语表演《感恩的心》，都围绕心这个主题，从心开始，从心出发！来自上海特区办公室的节目《风吹麦浪》，和这个收获的金秋也是很搭呢~管培生孙立娜小姐姐可以说是全场的vocal担当！',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image3],
    },
    {
      type: 1,
      title: '',
      src: [image4],
    },
    {
      type: 1,
      title: '',
      src: [image5],
    },
    {
      type: 1,
      title: '',
      src: [image6],
    },
    {
      type: 0,
      text: '各兄弟部门代表们也为上海特区1周年送上了最真挚的祝福...',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image7],
    },
    {
      type: 1,
      title: '',
      src: [image8],
    },
    {
      type: 0,
      text: '精心准备的主办方们',
      isIndent: false,
    },
    {
      type: 0,
      text: '控场&气氛营造一级棒的主持人们',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image9],
    },
    {
      type: 0,
      text: '「唱出你的热情，伸出你双手，让我拥抱着你的梦...」',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '安可了好几次的《明天会更好》，唱出了小伙伴们的愿望！特区明天会更好，叮咚明天会更好！',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '放肆青春 从心出发，是对青春的礼赞，也是不忘初心的坚守。有品质才有尊严，有规模才有担当，有效率才有生命！以此刻为契机，生命之战上海特区继续扬帆出发！',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image10],
    },
  ],
};
